import { render, staticRenderFns } from "./KFILanding.vue?vue&type=template&id=76402838&"
import script from "./KFILanding.vue?vue&type=script&lang=js&"
export * from "./KFILanding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports